import Modal from '../../../utils/modal';
import NormalButton from '../../Buttons/NormalButton';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { isCypress } from '../../../utils/useCypress';
import { setChoiceModal } from '../../../store/actions/modals.actions';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux-hooks';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: any) => ({
  root: {
    borderRadius: "10px",
    backgroundColor: theme.colors.white,
    width: "400px",
    maxWidth: '90vw',
    overflow: "auto",
    padding: "20px",
    margin: "20px",
    maxHeight: 'calc(100vh - 40px)',
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    '& p': {
      fontWeight: "bold",
      marginBottom: "0",
    },
  },
  text: {
    '& a': {
      color: theme.colors.primaryBlue[500],
    },
  },
  body: {
    marginTop: "20px",
    maxHeight: 'calc(100vh - 300px)',
    overflow: 'auto',
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: '16px',
    gap: '10px',
  },
}));

const ChoiceModal: React.FunctionComponent = () => {

  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const modalsData = useAppSelector((state: any) => state.modals);

  const title = modalsData.choiceModal.title;
  const content = modalsData.choiceModal.content;
  const choices = modalsData.choiceModal.choices;
  
  const onCloseModal = () => {
    const settings = {
      isOpen: false,
      title: null,
      content: null,
      choices: [],
    };
    dispatch(setChoiceModal(settings));
  };

  const handleClose = (e: any) => {
    e.stopPropagation();
    onCloseModal();
  };

  const handleAction = (e: any, type: any, action: any) => {
    e.preventDefault();
    e.stopPropagation();
    if(action) {
      action();
    }
    if(type === "close") {
      handleClose(e);
    }
  };

  return (
    <Modal 
      open={true}
      onClose={onCloseModal}
    >
      <div className={classes.root} data-cy={isCypress() ? "confirmModal" : null}>
        <div className={classes.header}>
          <div className={classes.wrapper}>
            <p>{title}</p>
          </div>
        </div>
        <div className={classes.body}>
          <p className={classes.text}>
            {content}
          </p>
        </div>
        <div className={classes.footer}>
          {
            choices.map((item: any, key: any) => (
              <NormalButton buttonType={item.buttonType ? item.buttonType : "primary"} onClick={(e: any) => handleAction(e, item.type ? item.type : "none", item.action)} key={`k_${key}`}>
                {item.text ? item.text : ""}
              </NormalButton>
            ))
          }
        </div>
      </div>
    </Modal>
  );
};  

export default ChoiceModal;